export default "__VITE_ASSET__373c0f0c__"